import React from "react";
import { CircleLogo } from "web/react/emo/circle-logo";
import { Text } from "web/react/emo/text";
import { VerifiedBadge } from "web/react/emo/verified-badge";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./retailer-with-logo.css";

export interface RetailerWithLogoProps {
    retailerName: string;
    retailerLogoURL?: string;
    isVerified?: boolean;
}

export function RetailerWithLogo({
    retailerName,
    retailerLogoURL,
    isVerified = false,
}: RetailerWithLogoProps): React.ReactElement {
    return (
        <div className={styles.container} data-testid="retailer-with-logo">
            <div className={styles.logoWrapper}>
                <CircleLogo size="xs" name={retailerName} imageURL={retailerLogoURL} />
            </div>
            <Text
                className={styles.retailerName}
                textStyle="body-xs"
                truncate
                lineLimit={1}
                dataTestId="from-retailer-name"
            >
                {gettext("in_stock_product.from_retailer", { retailer_name: retailerName })}
            </Text>
            {isVerified && <VerifiedBadge size="xs" />}
        </div>
    );
}
